let notices = require( './notices' );

let vibe_cake_masters_add_to_cart = function( $ ) {

	let $body,
		$add_to_cart_buttons,
		banner_show_time = 5000,
		anim_speed       = 400,
		hide_after_time_passed_timeout,
		show_after_hide_timeout,
		remove_timeout;

	let _init = function() {
		$body                = $( 'html body' );
		$add_to_cart_buttons = $( '.masters-add-to-cart' );

		_setup_body_triggers();

		if ( $add_to_cart_buttons.length > 0 ) {
			_setup_buttons();
		}
	};

	let _setup_body_triggers = function() {
		$body.on( 'masters-cart_update_buttons', ( e ) => {
			$add_to_cart_buttons = $( '.masters-add-to-cart' );

			_setup_buttons();
		} );

		$body.on( 'masters-cart-course_added_to_cart_body masters-cart-module_added_to_cart_body', ( e, response ) => {
			if ( response.cart_banner_html ) {
				_show_cart_banner( response.cart_banner_html );
			}

			if ( response.cart_count ) {
				_update_cart_count( response.cart_count );
			}
		} );

		$body.on( 'masters-cart-course_added_to_cart_body', ( e, response ) => {
			if ( response.notices ) {

				if ( response.notices.removed_modules ) {
					notices.add_notice( $( '.course-notices-wrapper' ), 'success', response.notices.removed_modules, false );
				}
			}
		} );

		$body.on( 'masters-cart_remove_item_success_body', ( e, response ) => {
			if ( response.cart_count ) {
				_update_cart_count( response.cart_count );
			}
		} );

		$body.on( 'masters-cart-module_add_to_cart_error_body', ( e, response ) => {
			if ( response.error ) {
				notices.add_notice( $( '.module-notices-wrapper' ), 'error', response.error, true );
			}
		} );
	};

	let _setup_buttons = function() {
		$add_to_cart_buttons.not( '.initialised' ).each( ( index, item ) => {
			let $button = $( item );

			$button.on( 'click', function( e ) {
				e.preventDefault();

				$button.loading();

				let clear_all = $( this ).data( 'clear-cart-before' ) ?? false;

				if ( $button.hasClass( 'module-add-to-cart' ) ) {
					let $form = $button.closest( '.module-add-to-cart-form' ),
						tier  = $form.find( 'input.module-tier:checked' ).val();

					add_to_cart( $( this ).data( 'module' ), 'module', $button, false, tier, clear_all );
				} else if ( $button.hasClass( 'course-add-to-cart' ) ) {
					add_to_cart( $( this ).data( 'course' ), 'course', $button, false, false, clear_all );
				}
			} );

			$button.on( 'masters-cart-course_add_to_cart_error masters-cart-module_add_to_cart_error', ( e, response ) => {
				$button.loaded();
			} );

			$button.addClass( 'initialised' );
		});

		$body.on( 'masters-cart-course_added_to_cart_body', ( e, response ) => {
			let $buttons = $( '.masters-add-to-cart[data-course="'+ response.course_id +'"]' );

			$buttons.replaceWith( response.new_button_html );
			$body.trigger( 'masters-cart_update_buttons' );
		} );

		$body.on( 'masters-cart-module_added_to_cart_body', ( e, response ) => {
			let $buttons = $( '.masters-add-to-cart[data-module="'+ response.module_id +'"]' );

			$buttons.closest( '.module-add-to-cart-form' ).replaceWith( response.new_button_html );
			$body.trigger( 'masters-cart_update_buttons' );
		} );
	};

	let add_to_cart = function( item_id, type= 'course', $element_to_refresh = false, subscription = false, tier = false, clear_cart_before = false ) {
		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_cart_ajax_add_nonce,
			action: 'vibe_cake_masters_cart_ajax_add',
			item_id: item_id,
			type: type,
			subscription: subscription ? 1 : 0,
			tier: tier,
			clear_before: clear_cart_before ? 1 : 0
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					if ( type === 'course' ) {
						$element_to_refresh.trigger( 'masters-cart-course_add_item_success', response );
					}  else if ( type === 'module' ) {
						$element_to_refresh.trigger( 'masters-cart-module_add_item_success', response );
					}
				}

				if ( type === 'course' ) {
					$body.trigger( 'masters-cart-course_added_to_cart_body', response );
				} else if ( type === 'module' ) {
					$body.trigger( 'masters-cart-module_added_to_cart_body', response );
				}
			} else {
				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					if ( type === 'course' ) {
						$element_to_refresh.trigger( 'masters-cart-course_add_to_cart_error', response );
					} else if ( type === 'module' ) {
						$element_to_refresh.trigger( 'masters-cart-module_add_to_cart_error', response );
					}
				}

				if ( type === 'course' ) {
					$body.trigger( 'masters-cart-course_add_to_cart_error_body', response );
				} else if ( type === 'module' ) {
					$body.trigger( 'masters-cart-module_add_to_cart_error_body', response );
				}
			}

			if ( response.nonce_replacement ) {
				VibeCakeMastersScriptData.vibe_cake_masters_cart_ajax_add_nonce = response.nonce_replacement;
			}
		} );
	};

	let remove_from_cart = function( item_id, type= 'course', $element_to_refresh = false ) {
		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_cart_ajax_remove_nonce,
			action: 'vibe_cake_masters_cart_ajax_remove',
			item_id: item_id,
			type: type,
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					$element_to_refresh.trigger( 'masters-cart_remove_item_success', response );
				}

				$body.trigger( 'masters-cart_remove_item_success_body', response );
			} else {
				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					$element_to_refresh.trigger( 'masters-cart_remove_item_error', response );
				}

				$body.trigger( 'masters-cart_remove_item_error_body', response );
			}
		} );
	};

	let _show_cart_banner = function( html ) {
		clearTimeout();

		if ( $( '#masters-cart-banner' ).length > 0 ) {
			_remove_cart_banner();

			if ( show_after_hide_timeout ) {
				clearTimeout( show_after_hide_timeout );
			}

			show_after_hide_timeout = setTimeout( function() {
				_show_cart_banner( html );
				}, anim_speed + 20 );
		} else {
			$( '#header' ).append( html );

			let $banner = $( '#masters-cart-banner' );

			$banner.slideDown( anim_speed );

			if ( hide_after_time_passed_timeout ) {
				clearTimeout( hide_after_time_passed_timeout );
			}

			hide_after_time_passed_timeout = setTimeout( () => {
				setTimeout( () => {
					_remove_cart_banner();
				}, banner_show_time );
			}, anim_speed );
		}
	};

	let _remove_cart_banner = function() {
		let $banner = $( '#masters-cart-banner' );

		if ( $banner.length > 0 ) {
			$banner.slideUp( anim_speed );

			if ( remove_timeout ) {
				clearTimeout( remove_timeout );
			}

			remove_timeout = setTimeout( () => {
				$banner.remove();
			}, anim_speed );
		}
	};

	let _update_cart_count = function( count ) {
		let $cart_count = $( '#masters-header-cart-count' );

		if ( count > 0 ) {
			$cart_count.removeClass( 'hidden' );
		} else {
			$cart_count.addClass( 'hidden' );
		}

		$cart_count.find( '.count' ).text( count );
	};

	$( document ).ready( _init );

	return {
		add_to_cart: add_to_cart,
		remove_from_cart: remove_from_cart,
	}

} ( jQuery );

module.exports = vibe_cake_masters_add_to_cart;